import {
  CsvExportDefinition,
  formatOrgTags,
  formatUnixSecondsDate
} from "../../common/csvExport";

interface OrgExportRecord {
  id: string | number;
  displayName?: string;
  orgTags?: string[];
  created?: number;
}

const dateOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "short",
  day: "numeric"
};

export const orgExportDefinition: CsvExportDefinition<OrgExportRecord> = {
  resource: "Org",
  filenameStem: "organizations",
  id: { header: "orgID", source: "id" },
  columns: [
    {
      key: "displayName",
      label: "Organization Name",
      source: "displayName",
      getValue: (r) => r.displayName
    },
    {
      key: "orgTags",
      label: "Tags",
      source: "orgTags",
      getValue: (r) => formatOrgTags(r.orgTags)
    },
    {
      key: "created",
      label: "Date Created",
      source: "created",
      getValue: (r) => formatUnixSecondsDate(r.created, dateOptions)
    }
  ]
};
